import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import FlexTable from "../../../components/ui-components/FlexTable";
import { fmtEur } from "./format";

const columns = [
  { Header: "Owner", accessor: "owner" },
  { Header: "Budgets", accessor: "budgets", align: "right" },
  { Header: "Cap", accessor: "capCents", align: "right", Cell: ({ value }) => fmtEur(value / 100) },
  { Header: "Projected", accessor: "projectedCents", align: "right", Cell: ({ value }) => fmtEur(value / 100) },
  { Header: "At risk", accessor: "atRiskCount", align: "right" },
  { Header: "On track", accessor: "onTrackCount", align: "right" },
];

/**
 * BudgetOwnershipTableBlock - per-owner rollup of budget count, cap/projected spend, and
 * at-risk vs. on-track counts (budget_ownership_table block type).
 *
 * GET /api/v1/board-reports/{boardReportId}/runs/{runId}/figures/budget-ownership -> envelope
 * key "budget_ownership" -> { owners: [BudgetOwnershipRow] } (backend internal/boardfigures/
 * budget_risk.go). The endpoint path has no "-table" suffix even though this block's
 * registry key does.
 */
const BudgetOwnershipTableBlock = ({ title = "Budget ownership", boardReportId, runId }) => {
  const { data, isLoading, error } = useBlockData(
    `/api/v1/board-reports/${boardReportId}/runs/${runId}/figures/budget-ownership`
  );

  const owners = data?.budget_ownership?.owners ?? [];

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error} className="a4-budget-ownership-table">
      <FlexTable columns={columns} data={owners} getRowId={(row) => row.owner} />
    </BaseBlock>
  );
};

BudgetOwnershipTableBlock.propTypes = {
  title: PropTypes.string,
  boardReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  runId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BudgetOwnershipTableBlock;
